//#region imports
import React, { use, useEffect, useMemo, useState } from 'react';

// redux
import { useDispatch, useSelector } from "react-redux";


// styling
import { Colors } from '_styles';

// spacing
import { Spacing } from '_styles';
import { EMPLOYEE_STATUS_META, timelineRoles } from '_utils/timeline-constants';
import { FaUser } from 'react-icons/fa';

//#endregion

const EmployeeProfilePicture = (props) => {

    //#region states
    const [emojiColor, setEmojiColor] = useState("grey");
    const [shiftStart, setShiftStart] = useState("");
    const [shiftEnd, setShiftEnd] = useState("");
    const [employeeIcon, setEmployeeIcon] = useState("");
    const [employeeRole, setEmployeeRole] = useState("");
    const [employeeEquipment, setEmployeeEquipment] = useState(false);
    //#endregion
    const employeeStatus = props?.employee?.status || props?.employeeStatus || "offline";
    const statusMeta = EMPLOYEE_STATUS_META[employeeStatus] || EMPLOYEE_STATUS_META.offline;
    //#region use effects

    // set employee equipment, icon and role
    useEffect(() => {
        if (!props?.employee) return;
        // set employee equipment
        if (props?.employee?.employeeEquipment) {
            setEmployeeEquipment(props?.employee?.employeeEquipment);
        }
        else {
            setEmployeeEquipment(false);
        }

        // set employee icon and role
        if (props?.employee?.role) {
            const found = timelineRoles.find(r => r?.value === props?.employee?.role);
            setEmployeeIcon(found?.icon ?? <FaUser />); // fallback default icon
            setEmployeeRole(found?.label ?? props?.employee?.role)
        } else {
            setEmployeeIcon(<FaUser />)
            setEmployeeRole("Not Selected")
        }
    }, [props?.employee]);

    // handle employee status
    useEffect(() => {
        // check employee status and set emoji color
        if (props?.employee?.status) {
            if (props?.employee?.status == "online") { setEmojiColor("green") } //TODO, handle bg color wih icon, with new function
            else { setEmojiColor("grey") }
        }
    }, [props?.employee?.status])

    // handle shift times
    useEffect(() => {
        if (props?.shift) {
            let start = props?.shift[0];
            let end = props?.shift[1];
            start = start.split(':');
            end = end.split(':');
            const startHour = start[0] % 12 || 12;
            const endHour = end[0] % 12 || 12;
            const startAmPm = start[0] < 12 ? 'am' : 'pm';
            const endAmPm = end[0] < 12 ? 'am' : 'pm';
            setShiftEnd(`${endHour}:${end[1]} ${endAmPm}`)
            setShiftStart(`${startHour}:${start[1]} ${startAmPm}`)
        }
    }, [props?.shift])

    //#endregion

    return (
        <div style={{ display: 'flex', flex: 1, width: '100%', padding: Spacing.SCALE_4, alignItems: 'center' }}>

            {/* profile pic circle + status */}
            <div style={{ flex: 1 }}>
                <div style={{ borderRadius: '50%' }}>

                    {/* employee icon */}
                    <div data-tippy-content={employeeRole} style={{
                        width: 40, height: 40, borderRadius: 50,
                        backgroundColor: Colors.PRM_LIGHT_BLUE,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}
                    >
                        {/* profile picture or initials */}
                        <span style={{ fontSize: 20, color: "#fff", justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            {employeeIcon}
                        </span>
                    </div>


                    {/* div for status */}
                    <div style={{
                        display: 'flex', justifyContent: 'flex-end', marginTop: -Spacing.SCALE_8,
                    }}>
                        <div
                            data-tippy-content={statusMeta.label}
                            style={{
                                width: 15,
                                height: 15,
                                borderRadius: 50,
                                backgroundColor: statusMeta.color,
                                borderStyle: 'solid',
                                borderWidth: 1.5,
                                borderColor: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: statusMeta.iconColor || 'white',
                                fontSize: employeeStatus === "onBreak" ? 8 : 9,
                                boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
                            }}
                        >
                            {statusMeta.icon}
                        </div>

                    </div>

                </div>
            </div>

            {/* employee name */}
            <div style={{ flex: 3, marginLeft: Spacing.SCALE_8 }}>
                {props?.showName &&
                    <div style={{ alignItems: "left", color: props?.glow ? 'black' : 'grey', }}>

                        {/* employee name */}
                        <p
                            style={{
                                fontSize: 12,
                                fontWeight: props?.glow ? "bold" : "500",
                                textAlign: "left",
                                margin: 0,
                                padding: 0
                            }}
                            data-tippy-content="Employee Name"
                        >
                            {props?.employee?.title ?? ""}
                        </p>


                        {/* shift times */}
                        {shiftStart && shiftEnd && <p style={{ fontSize: 10.5, margin: 0, padding: 0, }}>{`${shiftStart} - ${shiftEnd}`}</p>}

                        {/* equipment info */}
                        {employeeEquipment && <p style={{ fontSize: 10.5, margin: 0, padding: 0, color: 'lightgrey' }}>{employeeEquipment}</p>}

                    </div>
                }
            </div>

        </div>
    );
};

export default EmployeeProfilePicture;